export const USERS = 'Users';
export const USERS_TAG_TYPE = 'Users';
